module.exports = {
  "dof-btn-panel": {
    "width": "750",
    "height": "128",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "alignItems": "center",
    "justifyContent": "center",
    "opacity": 1
  },
  "btn-group-wrap": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "alignItems": "center",
    "justifyContent": "center",
    "borderTopLeftRadius": "64",
    "borderTopRightRadius": "64",
    "borderBottomRightRadius": "64",
    "borderBottomLeftRadius": "64",
    "overflow": "hidden"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Medium",
    "color": "#ffffff",
    "fontSize": "28",
    "lineHeight": "64",
    "paddingLeft": "32",
    "paddingRight": "32"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5909cc86!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-button-group/index.vue
// module id = 483
// module chunks = 0 1